export const initAIModelRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/ai-models",
          name: "ai-model",
          component: () => import("@/pages/manage/ai-models/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [
              config.roles.administrators,
              config.roles.siteEditors,
            ],
          },
        },
        {
          path: "/manage/ai-models/:id",
          name: "ai-model-id",
          component: () => import("@/pages/manage/ai-models/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [
              config.roles.administrators,
              config.roles.siteEditors,
            ],
          },
        },
      ];
